import _ from 'lodash'
import URLSearchParams from '@ungap/url-search-params'

const pendoIdentified = (state = false, action) => {
  const { pendo } = window
  switch (action.type) {
    case 'FETCH_CREDENTIALS_NO_AUTH':
      pendo.initialize()
      return false
    case 'FETCH_CREDENTIALS_SUCCESS':
      if (action.data) {
        let selectedAccount = 0
        if (_.has(action, 'data.selectedAccount')) {
          selectedAccount = _.get(action, 'data.selectedAccount')
        }
        else {
          const urlQueries = new URLSearchParams(window.location.search)
          if (urlQueries.has('selectedAccount')) {
            selectedAccount = urlQueries.get('selectedAccount')
          }
          else if (localStorage?.selectedAccount != null) {
            selectedAccount = +localStorage.selectedAccount || 0
          }
        }
        if (selectedAccount >= 0) {
          const supportAccountIds = _.get(action, 'data.credentials.supportAccountIds', [])
          if (selectedAccount > 0 && !supportAccountIds[selectedAccount]) {
            selectedAccount = 0
          }
          const account = supportAccountIds[selectedAccount]
          pendo.initialize({
            visitor: {
              id: _.get(action, 'data.credentials.email'),
              email: _.get(action, 'data.credentials.email'),
              displayName: _.get(action, 'data.credentials.displayName'),
              firstName: _.get(action, 'data.credentials.firstname'),
              lastName: _.get(action, 'data.credentials.lastname'),
            },
            account: {
              id: _.get(account, 'accountid'),
              name: _.get(account, 'name'),
            }
          })
          return true
        }
      }
      pendo.initialize()
      return false
    case 'SET_CURRENT_SUPPORT_ACCOUNT_INDEX':
      if (action.id != null) {
        const account = _.get(action, `supportAccountIds.${action.id}`)
        if (account) {
          pendo.updateOptions({
            account: {
              id: _.get(account, 'accountid'),
              name: _.get(account, 'name'),
            }
          })
          return true
        }
      }
      return state
    default:
      return state
  }
}

export default pendoIdentified
